export default __webpack_public_path__ + "static/ShamelFamily-SansLight-a1e9d78b1d65f5b87ec5b2db61470e84.ttf";